import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../../utility';

const initialState = {
	data: [],
	loading: false,
};

const getLifeClockStart = (state) => {
	return updateObject(state, { loading: true });
};

const getLifeClockSuccess = (state, action) => {
	return updateObject(state, {
		data: action.data,
		loading: false,
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_LIFE_CLOCK_START:
			return getLifeClockStart(state);
		case actionTypes.GET_LIFE_CLOCK_SUCCESS:
			return getLifeClockSuccess(state, action);

		default:
			return state;
	}
};

export default reducer;
